<template>
  <div style="position: relative">
    <v-container fluid class="grey lighten-4" pa-0>
      <v-row no-gutters style="container-data-filter-buttons">
        <v-col class="align-self-center" md="auto" xs="auto" sm="auto">
          <!-- Back button -->
          <crud-button
            x-large
            color="blue-grey darken-1"
            @clicked="back()"
            icon="fa-chevron-left"
            :tooltip="$t('global.crud.buttons.return')"
          />
        </v-col>
        <v-col
          cols="1"
          class="flex-grow-1 flex-shrink-0 container-data-filter-info"
        >
          <v-container fluid pa-0>
            <v-row>
              <v-col sm="12" cols="12">
                <div class="form-field-name">
                  {{ $t("timeSlotsClients.client") }}
                </div>
                <div class="form-field-value">
                  {{ dataFilter.clientCode }}&nbsp;-&nbsp;{{
                    dataFilter.clientName
                  }}
                </div>
              </v-col>
            </v-row>
          </v-container></v-col
        >
      </v-row>
    </v-container>
    <v-card flat>
      <div id="controlsContainer">
        <div
          class="card-title table-controls px-3 d-flex align-center justify-space-between"
        >
          <div>
            <!-- CRUD buttons -->
            <!-- dialog for creating item -->
            <crud-button
              v-if="$checkPermission('TIMESLOTSCLIENTS')"
              x-large
              color="light-blue lighten-2"
              @clicked="create()"
              icon="fa-plus"
              :tooltip="$t('global.crud.button.add')"
            />
          </div>
          <!-- center side -->
          <div>
            <!-- Search by fields -->
            <!-- Search in table -->
            <v-container id="filterContainer">
              <v-row>
                <v-col sm="5" lg="3" cols="12">
                  <v-dialog
                    ref="dialogTimeSlotClientsFrom"
                    v-model="modalTimeSlotClientsFrom"
                    :return-value.sync="filter.hourFromString"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.hourFromString"
                        :label="$t('timeSlots.timeSlotFrom')"
                        readonly
                        clearable
                        append-icon="far fa-clock"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="modalTimeSlotClientsFrom"
                      v-model="filter.hourFromString"
                      full-width
                      format="24hr"
                      :allowed-minutes="allowedStepTime"
                      @click:minute="
                        $refs.dialogTimeSlotClientsFrom.save(
                          filter.hourFromString
                        )
                      "
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalTimeSlotFrom = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="5" lg="3" cols="12">
                  <v-dialog
                    ref="dialogTimeSlotClientsTo"
                    v-model="modalTimeSlotClientsTo"
                    :return-value.sync="filter.hourToString"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="filter.hourToString"
                        :label="$t('timeSlots.timeSlotTo')"
                        readonly
                        clearable
                        append-icon="far fa-clock"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                      v-if="modalTimeSlotClientsTo"
                      v-model="filter.hourToString"
                      full-width
                      format="24hr"
                      :allowed-minutes="allowedStepTime"
                      @click:minute="
                        $refs.dialogTimeSlotClientsTo.save(filter.hourToString)
                      "
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="modalTimeSlotClientsTo = false"
                      >
                        {{ $t("global.cancel") }}
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
                <v-col sm="5" lg="3" cols="12">
                  <v-select
                    v-model="filter.deletedItems"
                    :items="deletedItemsValues"
                    :label="$t('global.status')"
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
            <!-- clear filters -->
          </div>
          <!-- right side -->
          <div>
            <!-- Refresh table -->
            <crud-button
              large
              color="blue"
              @clicked="refreshItemsView()"
              icon="fa-sync-alt"
              :tooltip="$t('global.crud.buttons.refreshTable')"
            />
            <ExportExcel
              url="/timeSlotsClients"
              :filter="this.filter"
              :filterExport="filterExport"
            />
            <ImportExcel
              url="/timeSlotsClients"
              @done="search"
              :filterImport="filterImport"
              v-if="$checkPermission('TIMESLOTSCLIENTS')"
            />
          </div>
        </div>
      </div>
      <div id="dataContainer">
        <!-- Table -->
        <v-data-table
          :headers="headers"
          :items="items"
          item-key="code"
          :options.sync="options"
          :page.sync="pagination.page"
          :server-items-length="pagination.totalItems"
          :no-results-text="$t('global.datatable.noMatchingResults')"
          :no-data-text="$t('global.datatable.noDataAvailable')"
          :footer-props="{
            'items-per-page-options': rowsPerPageItems,
            'show-first-last-page': true,
            'show-current-page': true
          }"
          :loading="loading"
          light
          multi-sort
          dense
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.code">
                <td>
                  <!-- Edit record -->
                  <crud-button
                    v-if="$checkPermission('TIMESLOTSCLIENTS')"
                    x-small
                    color="orange"
                    icon="fa-pen"
                    :tooltip="$t('global.crud.buttons.edit')"
                    @clicked="edit(item.code)"
                  ></crud-button>

                  <!-- Delete record -->
                  <crud-button
                    v-if="
                      (item.deletionDate === undefined ||
                        item.deletionDate === null) &&
                        $checkPermission('TIMESLOTSCLIENTS')
                    "
                    x-small
                    color="red"
                    icon="fa-trash"
                    :tooltip="$t('global.crud.buttons.delete')"
                    @clicked="suspend(item.code)"
                  ></crud-button>

                  <!-- Active record -->
                  <crud-button
                    v-else-if="$checkPermission('TIMESLOTSCLIENTS')"
                    x-small
                    color="green"
                    icon="fa-redo"
                    :tooltip="$t('global.crud.buttons.restore')"
                    @clicked="restore(item.code)"
                  ></crud-button>
                </td>
                <td>
                  {{ minutesToHour(item.hourFrom) }} -
                  {{ minutesToHour(item.hourTo) }}
                </td>
              </tr>
            </tbody>
          </template>
        </v-data-table>
      </div>
    </v-card>
    <v-dialog v-model="dialog" max-width="600" persistent no-click-animation>
      <validation-observer ref="obs" v-slot="{ invalid, validated, passes }">
        <v-card>
          <v-toolbar dark color="primary" dense flat>
            <v-toolbar-title class="white--text">
              {{ formTitle }}
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon @click.native="close()">
              <v-icon>fas fa-times</v-icon>
            </v-btn>
          </v-toolbar>

          <v-card-text class="details-list">
            <v-form>
              <v-container>
                <v-row>
                  <v-col>
                    <v-dialog
                      ref="dialogTimeSlotClientsFrom"
                      v-model="modalTimeSlotClientsFrom"
                      :return-value.sync="item.hourFromString"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider
                          :name="$t('timeSlotsClients.timeSlotFrom')"
                          rules="required"
                          v-slot="{ errors }"
                          vid="fieldTimeSlotClientsFrom"
                        >
                          <v-text-field
                            v-model="item.hourFromString"
                            :label="$t('timeSlotsClients.timeSlotFrom')"
                            readonly
                            required
                            append-icon="far fa-clock"
                            :error-messages="errors"
                            v-on="on"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-time-picker
                        v-if="modalTimeSlotClientsFrom"
                        v-model="item.hourFromString"
                        full-width
                        format="24hr"
                        :allowed-minutes="allowedStepTime"
                        @click:minute="
                          $refs.dialogTimeSlotClientsFrom.save(
                            item.hourFromString
                          )
                        "
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modalTimeSlotClientsFrom = false"
                        >
                          {{ $t("global.cancel") }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.dialogTimeSlotClientsFrom.save(
                              item.hourFromString
                            )
                          "
                        >
                          {{ $t("global.confirm") }}
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>

                  <v-col>
                    <v-dialog
                      ref="dialogTimeSlotClientsTo"
                      v-model="modalTimeSlotClientsTo"
                      :return-value.sync="item.hourToString"
                      persistent
                      width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <validation-provider
                          :name="$t('timeSlotsClients.timeSlotTo')"
                          rules="required|hourBefore:@fieldTimeSlotClientsFrom"
                          vid="fieldTimeSlotClientsTo"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="item.hourToString"
                            :label="$t('timeSlotsClients.timeSlotTo')"
                            readonly
                            required
                            append-icon="far fa-clock"
                            :error-messages="errors"
                            v-on="on"
                          ></v-text-field>
                        </validation-provider>
                      </template>
                      <v-time-picker
                        v-if="modalTimeSlotClientsTo"
                        v-model="item.hourToString"
                        full-width
                        format="24hr"
                        :allowed-minutes="allowedStepTime"
                        @click:minute="
                          $refs.dialogTimeSlotClientsTo.save(item.hourToString)
                        "
                      >
                        <v-spacer></v-spacer>
                        <v-btn
                          text
                          color="primary"
                          @click="modalTimeSlotClientsTo = false"
                        >
                          {{ $t("global.cancel") }}
                        </v-btn>
                        <v-btn
                          text
                          color="primary"
                          @click="
                            $refs.dialogTimeSlotClientsTo.save(
                              item.hourToString
                            )
                          "
                        >
                          {{ $t("global.confirm") }}
                        </v-btn>
                      </v-time-picker>
                    </v-dialog>
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="black" text @click.native="close()">
              {{ $t("global.buttons.close") }}
            </v-btn>
            <v-btn v-if="editMode" color="orange" text @click="passes(update)">
              {{ $t("global.buttons.update") }}
            </v-btn>
            <v-btn v-else color="green" text @click="passes(save)">
              {{ $t("global.buttons.create") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </validation-observer>
    </v-dialog>
  </div>
</template>

<style scoped>
.details-list {
  max-height: calc(100vh - 200px);
  overflow-y: auto;
}
</style>

<script>
import CrudButton from "@/components/Button.vue";
import localhttp from "../js/https-commons";
import {
  hourToMinutes,
  minutesToHour,
  excelTimeToMinutes
} from "@/js/utils.js";
import ExportExcel from "@/components/ExportExcel.vue";
import ImportExcel from "@/components/ImportExcel.vue";

const CONTEXT = "/timeSlotsClients";
const CONTEXT_CLIENTS = "/clients";
const ENTITY_NAME = "timeSlotClient.";

export default {
  components: {
    CrudButton,
    ExportExcel,
    ImportExcel
  },
  name: "Cliente",
  props: {
    client: {
      type: String,
      required: true
    }
  },
  data: () => ({
    modalTimeSlotClientsFrom: false,
    modalTimeSlotClientsTo: false,
    loading: false,
    searchTable: "",
    dataFilter: {
      clientCode: "",
      clientName: ""
    },
    filter: {
      hourFrom: "",
      hourFromString: "",
      hourTo: "",
      hourToString: "",
      deletedItems: "ALL"
    },
    searchTableWaiting: false,
    editMode: false,
    dialog: false,
    item: {},
    items: [],
    options: {},
    pagination: {
      totalItems: 0,
      page: 1
    },
    rowsPerPageItems: [10, 20, 30, 40]
  }),
  computed: {
    deletedItemsValues: function() {
      return [
        { text: this.$t("global.status.all"), value: "ALL" },
        { text: this.$t("global.status.active"), value: "ACTIVE" },
        { text: this.$t("global.status.deleted"), value: "DELETED" }
      ];
    },
    formTitle() {
      return this.editMode
        ? this.$t("timeSlotsClients.title.edit")
        : this.$t("timeSlotsClients.title.new");
    },
    headers() {
      return [
        {
          text: this.$t("global.datatable.header.actions"),
          value: "actions",
          sortable: false
        },
        {
          text: this.$t("timeSlotsClients.datatable.timeSlot"),
          value: ENTITY_NAME + "hourFrom"
        }
      ];
    }
  },
  watch: {
    options: {
      handler() {
        this.search();
      },
      deep: true
    },
    "pagination.totalItems": {
      handler() {
        this.pagination.page = 1;
      },
      deep: true
    },
    searchTable() {
      if (!this.searchTableWaiting) {
        setTimeout(() => {
          this.search();
          this.searchTableWaiting = false;
        }, 500);
      }
      this.searchTableWaiting = true;
    }
  },
  methods: {
    search() {
      console.debug("Search elements");

      // Items have already been requested
      if (this.loading) return;

      this.loading = true;

      // Parse hour:time to minutes
      this.filter.hourFrom =
        this.filter.hourFromString != null
          ? hourToMinutes(this.filter.hourFromString)
          : null;
      this.filter.hourTo =
        this.filter.hourToString != null
          ? hourToMinutes(this.filter.hourToString)
          : null;

      const { sortBy, sortDesc, page, itemsPerPage } = this.options;
      this.filter.sortBy = sortBy;
      this.filter.sortDesc = sortDesc;
      this.filter.page = page;
      this.filter.itemsPerPage = itemsPerPage;

      localhttp
        .post(CONTEXT + "/allPagination/" + this.client, this.filter)
        .then(response => {
          this.pagination.totalItems = response.data.totalElements;
          this.items = response.data.content;
          this.loading = false;
        })
        .catch(e => {
          console.log(e);
          this.loading = false;
          this.$showError();
        });
    },
    create() {
      console.debug("Create element");
      this.editMode = false;
      this.resetDialog();
      this.dialog = true;
    },
    async save() {
      console.debug("Save form");

      this.item.hourFrom = hourToMinutes(this.item.hourFromString);
      this.item.hourTo = hourToMinutes(this.item.hourToString);
      this.item.clientCode = this.client;

      localhttp
        .post(CONTEXT + "/create", this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    edit(id) {
      console.debug("Edit element " + id);
      this.editMode = true;
      this.resetDialog();
      localhttp
        .get(CONTEXT + "/" + id)
        .then(response => {
          this.item = response.data;
          this.editPrepare(this.item);
          this.dialog = true;
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    editPrepare(item) {
      item.hourFromString = minutesToHour(item.hourFrom);
      item.hourToString = minutesToHour(item.hourTo);
    },
    async update() {
      console.debug("Update form");

      this.item.hourFrom = hourToMinutes(this.item.hourFromString);
      this.item.hourTo = hourToMinutes(this.item.hourToString);

      localhttp
        .put(CONTEXT + "/update/" + this.item.code, this.item)
        .then(response => {
          console.log(response.data);
          this.close();
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    async suspend(id) {
      console.debug("Suspend element " + id);
      if (
        await this.$root.$confirm(
          this.$t("global.confirm"),
          this.$t("global.action.suspend.confirm"),
          { color: "blue" }
        )
      ) {
        localhttp
          .put(CONTEXT + "/delete/" + id)
          .then(response => {
            console.log(response.data);
            this.search();
          })
          .catch(e => {
            console.log(e);
            this.$showErrorCode(e.response.status);
          });
      }
    },
    restore(id) {
      console.debug("Restore element " + id);
      localhttp
        .put(CONTEXT + "/activate/" + id)
        .then(response => {
          console.log(response.data);
          this.search();
        })
        .catch(e => {
          console.log(e);
          this.$showErrorCode(e.response.status);
        });
    },
    refreshItemsView() {
      console.debug("Refresh table");
      this.search();
    },
    close() {
      this.dialog = false;
    },
    resetDialog() {
      this.item = {};
      requestAnimationFrame(() => {
        if (this.$refs.obs !== undefined) {
          this.$refs.obs.reset();
        }
      });
    },
    filterExport(jsonData) {
      jsonData.forEach(function(v) {
        delete v.client;
        v.hourFrom = minutesToHour(v.hourFrom);
        v.hourTo = minutesToHour(v.hourTo);
      });
    },
    filterImport(jsonData) {
      jsonData.forEach(function(v) {
        v.hourFrom = excelTimeToMinutes(v.hourFrom);
        v.hourTo = excelTimeToMinutes(v.hourTo);
      });
    },
    back() {
      this.$router.push({
        name: "clients"
      });
    },
    allowedStepTime: m => m % 5 === 0,
    hourToMinutes,
    minutesToHour
  },
  beforeMount() {
    this.client = this.$props.client;
    localhttp
      .get(CONTEXT_CLIENTS + "/" + this.$props.client)
      .then(response => {
        this.dataFilter.clientCode = response.data.code;
        this.dataFilter.clientName = response.data.name;
      })
      .catch(e => {
        console.log(e);
        this.$showError();
      });
  }
};
</script>
